import cn from "classnames";
import React from "react";
import ContactSupportIcon from "../svgComponents/ContactSupportIcon";
import EmergencyIcon from "../svgComponents/EmergencyIcon";
import OverviewSvg from "../svgComponents/OverviewSvg";
import PrivacyIcon from "../svgComponents/PrivacyIcon";
import RequestIcon from "../svgComponents/RequestIcon";
import RoadMapSvg from "../svgComponents/RoadMapSvg";
import TermsIcon from "../svgComponents/TermsIcon";
import XBullRunSvg from "../svgComponents/XBullRunSvg";
import FooterItem from "./FooterItem/FooterItem";
import FooterLogo from "./FooterLogo/FooterLogo";
import SocialMediaLink from "./SocialMediaLink/SocialMediaLink";
import { socialMediaLinks } from "./constants";

const FooterModal = ({ isOpen, footerRef, onClose }) => {
  const date = new Date();
  const currentYear = date.getFullYear();
  return (
    <>
      <div
        className={cn(
          "w-full h-dvh fixed top-0 transition-all ease-in-out duration-700 right-0 bg-semiBlack left-0 opacity-0 sm:hidden",
          { "opacity-100 z-[999] blur-sm": isOpen }
        )}
      />
      <footer
        ref={footerRef}
        className={cn(
          "w-3/4 -translate-x-full top-0 sm:-top-10 left-0 sm:left-5 sm:-translate-y-[calc(100%)] sm:translate-x-0  transition-all ease-in-out duration-700 opacity-0 flex flex-col justify-between sm:block min-h-dvh sm:min-h-fit sm:w-[366px] absolute py-10 sm:py-6 bg-white sm:rounded-3xl z-1000 dark:bg-[#1D1C2D] shadow-smallShadow",
          {
            "translate-x-0 opacity-100 sm:!translate-y-[100px]": isOpen,
          }
        )}
      >
        <div>
          <FooterLogo />
          <section className="px-6 pb-3 sm:border-b border-lightGrayBlue dark:border-darkSlateBlue">
            <FooterItem
              itemImage={<OverviewSvg />}
              itemDescription={"Overview"}
              href={"#"}
            />

            <FooterItem
              itemImage={<RoadMapSvg />}
              itemDescription={"Roadmap"}
              href={"#"}
            />
          </section>
          <section className="px-6 py-3 sm:border-y border-lightGrayBlue dark:border-darkSlateBlue">
            <FooterItem
              itemImage={<TermsIcon />}
              itemDescription={"Terms of Use"}
              href={
                "https://xbullrun.gitbook.io/project-x/terms-of-services/privacy-policy"
              }
            />
            <FooterItem
              itemImage={<PrivacyIcon />}
              itemDescription={"Privacy Policy"}
              href={
                "https://xbullrun.gitbook.io/project-x/terms-of-services/privacy-policy/xbr-protocol-privacy-policy"
              }
            />

            <FooterItem
              itemImage={<EmergencyIcon />}
              itemDescription={"Earning Disclaimer"}
              href={"#"}
            />
          </section>
          <section className="px-6 py-3 sm:mb-0 sm:border-b border-lightGrayBlue dark:border-darkSlateBlue">
            <FooterItem
              itemImage={<RequestIcon />}
              itemDescription={"Request Form"}
              href={"#"}
            />

            <FooterItem
              itemImage={<ContactSupportIcon />}
              itemDescription={"Contact Support"}
              href={"#"}
            />
          </section>
        </div>
        <section className="px-8 pt-6">
          <div className="mb-6">
            <div className="mb-4 hidden sm:block">
              <XBullRunSvg />
            </div>
            <p className="text-xs text-lightBlack leading-[14.4px] dark:text-semiWhite">
              {`©${currentYear} XBR FOUNDATION LAB`}
            </p>
          </div>
          <div className="flex gap-2 sm:gap-[6px] flex-wrap">
            {socialMediaLinks.map(({ id, href, linkImage }) => (
              <SocialMediaLink key={id} href={href} linkImage={linkImage} />
            ))}
          </div>
        </section>
      </footer>
    </>
  );
};

export default FooterModal;
